import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {Toast} from 'app/shared/toast/toast';

@Component({
   selector: 'app-forgot-password',
   templateUrl: './forgot-password.component.html',
   styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
   @ViewChild('resetpw_email', {static: true}) input: ElementRef;
   @ViewChild('button') button: LoadingButtonComponent;
   errorMessage: string;

   constructor(private dialogRef: MatDialogRef<ForgotPasswordComponent>,
               private service: IdexService,
               public toast: Toast) {
   }

   ngOnInit() {
      this.input.nativeElement.focus();
   }

   onSubmit() {
      this.errorMessage = null;
      this.service.forgotPassword(this.input.nativeElement.value)
         .subscribe(
            data => {
               this.dialogRef.close();
               this.toast.info(data);
            },
            error => {
               console.log(error);
               this.button.reset();
               this.errorMessage = <any>error;
            }
         );
   }

   validate() {
      const inputValue = this.input.nativeElement.value.trim();
      this.button.disabled = !(inputValue.length > 0);
   }
}
